// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3bTEn","title":"ClientCherryInfo_title__W4Xeb","itemText":"ClientCherryInfo_itemText__KnCqB"};